import React from 'react';
import ReactDOM from 'react-dom/client';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { NextUIProvider } from '@nextui-org/react';
import { I18nextProvider } from 'react-i18next';
import { QueryClientProvider } from '@tanstack/react-query';
import { AuthHOC } from '@/hoc/Auth';
import i18n from '@utils/translations/i18n';
import queryClient from '@utils/queryClient';
import App from './App';
import './index.css';
import * as Sentry from '@sentry/react';

Sentry.init({
  dsn: 'https://520bc6007e4a9973886782978ceae7f3@o4506589808820224.ingest.us.sentry.io/4506590260625408',
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.browserProfilingIntegration(),
    Sentry.feedbackIntegration({
      colorScheme: 'system',
      isNameRequired: true,
      isEmailRequired: true,
    }),
  ],
  tracesSampleRate: 1.0,
  tracePropagationTargets: ['localhost', /https:\/\/api\.foodsa\.app/],
  profilesSampleRate: 1.0,
  environment: import.meta.env.VITE_ENVS,
});

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  // <React.StrictMode>
  <QueryClientProvider client={queryClient}>
    <NextUIProvider>
      <ReactQueryDevtools buttonPosition="bottom-left" />
      <I18nextProvider i18n={i18n}>
        <BrowserRouter>
          <AuthHOC>
            <HelmetProvider>
              <App />
            </HelmetProvider>
          </AuthHOC>
        </BrowserRouter>
      </I18nextProvider>
    </NextUIProvider>
  </QueryClientProvider>
  // </React.StrictMode>
);
